module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M0 9.74h6.667V32H0V9.74zm3.333-2.783C1.333 6.957 0 5.38 0 3.432 0 1.485 1.333 0 3.333 0s3.251 1.485 3.334 3.432c0 1.948-1.251 3.525-3.334 3.525zm20.598 2.782c4.452 0 8.069 3.195 8.069 9.678V32h-6.667V19.478c0-2.305-1.79-4.174-4-4.174-2.209 0-4 1.869-4 4.174V32h-6.666V9.74h6.666v2.999s2.238-3 6.598-3z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/linkedin.svg
// module id = 680
// module chunks = 0